<template>
  <ion-page>
    <master-layout pageTitle="ثبت ورودی انبار">

      <div class="card">
        <div class="card-header">
          <h3 class="card-title">ثبت ورودی انبار</h3>
        </div>
        <div class="card-body">
          <div class="form-group">
            <label>شماره حواله</label>
            <input type="text" name="draft_number" class="form-control draft_number" v-model="draft_number"
                   placeholder="شماره حواله">
          </div>
        </div>
      </div>

      <h4>اقلام فاکتور</h4>
      <div class="card">
        <div class="card-body">
          <div class="item">
            <div>ردیف</div>
          </div>
          <div class="item">
            <div>محصول</div>
            <div>
              <ali-ajax-select :reset="resetProductSelect" :index="index" :on-change="getProductAttr"
                               route="app/GetProductForSelect"
                               title="محصولات"
                               itemTitle="title" name="product_id" desc="جستجو محصول..." itemId="_id"></ali-ajax-select>

            </div>
          </div>
          <div class="item">
            <div>ویژگی</div>
            <div>
              <ali-select :on-change="reg_attr" v-if="attrItems.length" :items="attrItems"
                          search="true" title="ویژگی"
                          itemTitle="str" desc="ویژگی را انتخاب کنید!!!" name="attr_hash" itemId="hash"></ali-select>
            </div>
          </div>
          <div class="item">
            <div>تعداد</div>
            <div>
              <input type="text"
                     v-model="quantity"
                     class="form-control quantity form-control-sm"
                     placeholder="تعداد...">
            </div>
          </div>
          <div class="item">
            <div>قیمت خرید</div>
            <div>
              <input type="text"
                     v-model="buy_price"
                     class="form-control [only_number] buy_price form-control-sm"
                     placeholder="قیمت خرید...">
            </div>
          </div>
          <div class="item">
            <div class="total_tr_price"></div>
          </div>
          <div class="item">
            <div class="w-50 ion-padding">

            </div>
            <div class="w-50 ion-padding">
              <button @click="addItem" type="button" class="btn btn-success btn-block">
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table">
          <thead>
          <tr>
            <th>ردیف</th>
            <th>محصول</th>
            <th>ویژگی</th>
            <th>تعداد</th>
            <th>قیمت خرید</th>
            <th>جمع کل</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in items" :key="index">
            <td>
              <button @click="deleteItem(index)" type="button" class="btn btn-danger"><i
                  class="fas fa-times "></i></button>
              {{ index + 1 }}
            </td>
            <td>
              {{ item.product.title }}
            </td>
            <td>
              {{ item.attrObject?item.attrObject.str:'--' }}
            </td>
            <td>
              <input type="text" @keyup="setQuantity($event)" name="quantity" :data-index="index"
                     class="form-control quantity form-control-sm" v-model="item.quantity"
                     placeholder="تعداد...">
            </td>
            <td>
              <input type="text" @keyup="setBuyPrice($event)" :data-index="index" name="buy_price"
                     class="form-control [only_number] buy_price form-control-sm" v-model="item.buy_price"
                     placeholder="قیمت خرید...">
            </td>
            <td>
              <money :number="item.total"/>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="card">
        <div class="card-body">

          <div class="form-group center">
            <ImagePicker name="file_id[]"></ImagePicker>
          </div>

          <div class="form-group">
            <label>توضیحات</label>
            <textarea class="form-control content" v-model="content" name="content"
                      placeholder="توضیحات را وارد کنید..."></textarea>
          </div>
          <button class="btn btn-success" type="button" @click="submit()">افزودن به انبار</button>
        </div>
      </div>
      <br/>
      <br/>
    </master-layout>
    <div class="total-container">
      <table>
        <thead></thead>
        <tbody>
        <tr class="table-danger">
          <th>
            تعداد اقلام :
            <money :number="items.length"/>
          </th>
          <th>
            جمع قیمت خرید :
            <money :number="total_buy_price"/>
            تومان
          </th>
        </tr>
        </tbody>
      </table>
    </div>
  </ion-page>
</template>

<script>
import {
  IonPage
} from "@ionic/vue";
import ImagePicker from "@/components/ImagePicker";
import AliSelect from "@/components/aliSelect/index";
import AliAjaxSelect from "@/components/aliAjaxSelect/index";
import Money from "@/components/Money";
import {mapActions} from "vuex";
import {showSystemNoti} from "@/shared/helper";

export default {
  data()
  {
    return {
      id: null,
      total_buy_price: 0,
      draft_number: '',
      content: '',
      resetProductSelect: 0,

      product: null,
      product_id: null,
      product_type: '',
      quantity: '',
      buy_price: '',
      attrItems: [],
      attr: null,
      attrObject: null,

      items: []
    };
  },
  async created()
  {
    this.id = this.$route.params.warehouseId;
  },
  methods: {
    getProductAttr: async function (c)
    {
      if (c && c.length)
      {
        c = c[0];
        this.product_id = c._id;
        this.product_type = c.product_type;
        if (c.product_type === 'simple')
        {
          this.attrItems = [];
          this.attr = null;
        }
        else
        {
          const attrs = await this.getProductVariableAttr(c._id);
          if (attrs && attrs.length)
          {
            this.attrItems = attrs;
          }
          else
          {
            this.attrItems = [];
            this.attr = null;
          }
        }
        this.product = c;
      }
      else
      {
        this.attrItems = [];
        this.product_id = null;
      }
    },
    reg_attr: async function (a)
    {
      if (a && a.length)
      {
        this.attr = a[0].hash;
        this.attrObject = a[0];
      }
      else
        this.attr = null;
    },
    setQuantity: function (event)
    {
      const index = event.target.dataset.index;
      this.items[index].quantity = event.target.value;
      let n = Number(event.target.value);
      if (isNaN(n))
        n = 0;
      this.items[index].quantity = n;
      this.items[index].total = this.items[index].quantity * this.items[index].buy_price;
      this.setTotalBuyPrice();
    },
    setBuyPrice: function (event)
    {
      const index = event.target.dataset.index;
      let n = Number(event.target.value);
      if (isNaN(n))
        n = 0;
      this.items[index].buy_price = n;
      this.items[index].total = this.items[index].quantity * this.items[index].buy_price;
      this.setTotalBuyPrice();
    },
    setTotalBuyPrice: function ()
    {
      let t = 0;
      for (let i = 0; i < this.items.length; i++)
      {
        let n = 0;
        if (this.items[i].buy_price && this.items[i].quantity)
        {
          n = Number(this.items[i].buy_price * this.items[i].quantity)
        }
        t += n;
      }
      this.total_buy_price = t;
    },
    ...mapActions("app", {
      getProductVariableAttr: 'getProductVariableAttr'
    }),
    ...mapActions("warehouse", {
      addProductToWarehouse: 'addProductToWarehouse'
    }),
    addItem: function ()
    {
      if (!this.product_id)
      {
        return showSystemNoti('danger', 'لطفا محصول را انتخاب نمایید');
      }
      if (this.product_type !== 'simple' && !this.attr)
      {
        return showSystemNoti('danger', 'لطفا ویژگی محصول را انتخاب نمایید');
      }
      if (!this.quantity)
      {
        return showSystemNoti('danger', 'لطفا تعداد را وارد کنید.');
      }
      if (isNaN(this.quantity))
      {
        return showSystemNoti('danger', 'تعداد باید عدد باشد.');
      }
      if (!this.buy_price)
      {
        return showSystemNoti('danger', 'لطفا قیمت خرید را وارد کنید.');
      }
      if (isNaN(this.buy_price))
      {
        return showSystemNoti('danger', 'قیمت خرید باید عدد باشد.');
      }
      const total = this.buy_price * this.quantity;
      this.items.push(
          {
            product: this.product,
            product_id: this.product_id,
            product_type: this.product_type,
            quantity: this.quantity,
            buy_price: this.buy_price,
            attrItems: this.attrItems,
            attr: this.attr,
            attrObject: this.attrObject,
            total: total
          });


      this.resetProductSelect++;
      this.product = null;
      this.product_id = null;
      this.product_type = '';
      this.quantity = '';
      this.buy_price = '';
      this.attrItems = [];
      this.attrObject = null;
      this.attr = null;

      this.setTotalBuyPrice()

    },
    deleteItem: function (index)
    {
      this.items.splice(index, 1);
      this.setTotalBuyPrice();
    },
    submit: async function ()
    {
      /**
       * ToDo:
       *  file ids
       */
      const data = {
        "warehouse_id": this.id,
        "items": this.items,
        "file_ids": [],
        "draft_number": this.draft_number,
        "content": this.content
      };
      const result = await this.addProductToWarehouse(data);
      if (result)
      {
        if (result.ok)
        {
          showSystemNoti('success', result.message);

          this.total_buy_price = 0;
          this.draft_number = '';
          this.content = ''
          this.items = []
          this.setTotalBuyPrice()
        }
        else
          showSystemNoti('danger', result.error);
      }

    }
  },
  components: {
    ImagePicker,
    AliAjaxSelect,
    AliSelect,
    Money,
    IonPage
  }
};
</script>

<style scoped>

.total-container{
  position: fixed;
  bottom: 61px;
  font-size: 13px;
  text-align: center;
  width: 100%;
  background: #ffffff;
  padding: 8px;
  box-shadow: 0 0 5px 0 rgba(0,0,0,0.5);
}
.total-container table{
  width: 100%;
}

</style>